var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('at-date-input',{attrs:{"label":_vm.label,"required":_vm.required,"min":_vm.minBdate,"max":_vm.maxBdate,"flat":_vm.flat,"solo":_vm.solo},model:{value:(_vm.birthDate),callback:function ($$v) {_vm.birthDate=$$v},expression:"birthDate"}})}
var staticRenderFns = []

export { render, staticRenderFns }